import Immutable from 'seamless-immutable';
import _ from 'lodash';

const reducerDotPath = `main.states.clientNotices`;
const createActionName = name => `app/${reducerDotPath}/${name}`;

// ACTIONS
const INIT_STATE = 'INIT_STATE';
const ADD_CLIENT_NOTICE = 'ADD_CLIENT_NOTICE';

const createReducer = () => {
  function stateDefault() {
    return {
      items: []
    };
  }

  const initialState = Immutable(stateDefault());
  return function reduce(state = initialState, action = {}) {
    switch (action.type) {
      case createActionName(INIT_STATE):
        return Immutable(stateDefault());
      case createActionName(ADD_CLIENT_NOTICE):
        return {
          ...state,
          items: [action.notice, ...state.items]
        };
      default:
        return state;
    }
  };
};

export function createReduceObject(combineName, reducerName) {
  const reduceObject = {};
  reduceObject[reducerName] = createReducer(`${combineName}.${reducerName}`);
  return reduceObject;
}

// ACTIONS CREATOR
export const addClientNotice = notice => ({
  type: createActionName(ADD_CLIENT_NOTICE),
  notice
});

// SELECTORS
export const getState = state => _.get(state, reducerDotPath);
export function getClientNotices(state) {
  return getState(state).items;
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/main/reducers/static/states/clientNotices/reducer.js